import Request from 'components/Request';
import { assignPage } from 'navigation/pageLocation';

// Request.apiv1Post does not attach the CSRF token, and the account deletion
// endpoints check it, so add the page's token field explicitly.
export const csrfParameters = () => ({ [window.theSecretField]: window.theSecret });

export const postWithCsrf = (action, parameters = {}) => {
	return Promise.resolve(Request.apiv1Post(action, { ...parameters, ...csrfParameters() }))
		.then((response) => {
			if(!response || response.success !== true) {
				return Promise.reject({ responseJSON: response || {} });
			}
			return response;
		});
};

export const errorMessageFromFailure = (failure, fallbackMessage) => {
	if(failure && failure.responseJSON && failure.responseJSON.error) {
		return failure.responseJSON.error;
	}
	return fallbackMessage;
};

export const goToHomePage = () => {
	assignPage(`${window.siteUrl}/`);
};
